"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _flightDropdown = _interopRequireDefault(require("./flight-dropdown"));
var _flightTypeahead = _interopRequireDefault(require("./flight-typeahead"));
var _dateHelper = _interopRequireDefault(require("static-site-generator-shared/plugins/lib/dateHelper"));
var _engineHelper = _interopRequireDefault(require("../engineHelper"));
var _tracker = _interopRequireDefault(require("static-site-generator-shared/plugins/lib/tracker"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class FlightInput extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      flightNumber: props.activeFlight || '',
      showFlightInput: false
    };
    this.handleFlightText = this.handleFlightText.bind(this);
    this.blurFlightInput = this.blurFlightInput.bind(this);
    this.triggerFlightCodeChange = this.triggerFlightCodeChange.bind(this);
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (_engineHelper.default.checkUpdated(nextState.flightNumber, this.state.flightNumber)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.departure, this.props.departure)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.departureTime, this.props.departureTime)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.departureTimeMax, this.props.departureTimeMax)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.departureTimeMin, this.props.departureTimeMin)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.returnTime, this.props.returnTime)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.location, this.props.location)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.cookieName, this.props.cookieName)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.terminal, this.props.terminal)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.onChange, this.props.onChange)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.showFlightInput, this.state.showFlightInput)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.showFlightDropdown, this.props.showFlightDropdown)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.arrivalDate, this.props.arrivalDate)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.startTime, this.props.startTime)) return true;
    return false;
  }
  triggerFlightCodeChange(flightNumber, isVisible = false) {
    const flightcode = flightNumber ? flightNumber.flight.code : false;
    switch (flightcode) {
      case 'flight_not_listed':
      case 'flight_incorrect':
        isVisible = true;
        break;
    }
    this.setState({
      showFlightInput: isVisible,
      flightNumber: flightcode
    });
    if (this.props.onChange) this.props.onChange(flightNumber);
    return isVisible;
  }
  handleFlightText(flightFound) {
    if (!flightFound || !flightFound.flight.code) return;
    const {
      departure = {},
      flight
    } = flightFound;
    const flightTime = departure.time ? departure.time + ' ' : '';
    const flightCode = flight.matched && flight.matched.indexOf('undefined') < 0 ? flight.matched.replace(flight.code + '/', '') : flight.code;
    return flightTime + flightCode;
  }

  /**
    Handles when the manual flight input field is blurred. Sets a cookie and tracking values
  */
  blurFlightInput() {
    const {
      location,
      arrivalDate,
      departureTime
    } = this.props;
    const {
      flightNumber
    } = this.state;
    if (!flightNumber || !location || !arrivalDate || !departureTime) return;
    const date = `${new Date(arrivalDate).getFullYear()}-${_dateHelper.default.pad(new Date(arrivalDate).getMonth() + 1, 2)}-${_dateHelper.default.pad(new Date(arrivalDate).getDate(), 2)}`;
    _tracker.default.track('flight_inline_manual_entered', `${flightNumber},${location},${date},${departureTime}`); // TEXT,LOC,ARRIVALDATE(yyyy-mm-dd),FLIGHTTIMEHOUR(hhmm)
  }
  getActiveFlightNumber() {
    const {
      flightNumber
    } = this.state;
    if (flightNumber && flightNumber.indexOf('_') < 0) return flightNumber;
    return false;
  }
  render() {
    const {
      searchTimeout,
      minTextLimit,
      formSettings,
      name,
      label,
      tip,
      id,
      showFlightDropdown,
      flightInput: {
        inputLabel,
        placeholder
      }
    } = this.props;
    const {
      showFlightInput,
      flightNumber
    } = this.state;
    const activeFlightNumber = this.getActiveFlightNumber();
    const mainWrapperClass = (0, _classnames.default)({
      'flightInput': true,
      'col-md-1': true,
      'col-xs-3': true
    });
    return /*#__PURE__*/_react.default.createElement("li", {
      className: mainWrapperClass
    }, /*#__PURE__*/_react.default.createElement("input", {
      type: "hidden",
      name: name,
      value: activeFlightNumber || ''
    }), !showFlightDropdown && /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: id
    }, label), /*#__PURE__*/_react.default.createElement(_flightDropdown.default, {
      ref: c => {
        this.flightSearch = c;
      },
      id: id,
      name: "flight_number_dropdown",
      departure: this.props.departure,
      departureTime: this.props.departureTime,
      startTime: this.props.startTime,
      location: this.props.location,
      terminal: this.props.terminal,
      onChange: this.triggerFlightCodeChange,
      trackingPrefix: "flight_inline_",
      flightEndpoint: formSettings.flightSearch,
      searchTimeout: searchTimeout
    }), showFlightInput && showFlightDropdown && /*#__PURE__*/_react.default.createElement("div", {
      className: "form-group unlistedFlightInput"
    }, /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: 'flight_number_lookup'
    }, inputLabel), /*#__PURE__*/_react.default.createElement(_flightTypeahead.default, {
      flightSearchInputRef: c => {
        this._flightSearchInput = c;
      },
      id: id,
      location: this.props.location,
      departure: this.props.departure,
      customChosenText: this.handleFlightText,
      trackingPrefix: "flight_inline_manual_",
      name: "flight_number_lookup",
      onChange: this.triggerFlightCodeChange,
      activeFlight: flightNumber,
      flightEndpoint: formSettings.flightSearch,
      searchTimeout: searchTimeout,
      minTextLimit: minTextLimit,
      placeHolder: placeholder
    })), /*#__PURE__*/_react.default.createElement("p", {
      className: "small"
    }, tip));
  }
}
FlightInput.propTypes = {
  name: _propTypes.string,
  activeFlight: _propTypes.string,
  cookieName: _propTypes.string,
  departure: (0, _propTypes.oneOfType)([_propTypes.number, (0, _propTypes.instanceOf)(Date)]),
  departureTime: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
  departureTimeMax: _propTypes.number,
  departureTimeMin: _propTypes.number,
  returnTime: _propTypes.string,
  location: _propTypes.string,
  label: _propTypes.string,
  tip: _propTypes.string,
  searchTimeout: _propTypes.number,
  minTextLimit: _propTypes.number,
  terminal: _propTypes.string,
  onChange: _propTypes.func,
  id: _propTypes.string,
  showFlightDropdown: _propTypes.bool,
  flightInput: _propTypes.object,
  arrivalDate: (0, _propTypes.oneOfType)([_propTypes.number, (0, _propTypes.instanceOf)(Date)]),
  startTime: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
  formSettings: _propTypes.object
};
FlightInput.defaultProps = {
  cookieName: 'FlightNumber',
  label: 'Flying to/with',
  tip: 'For our best prices & most intelligent recommendations.',
  showFlightDropdown: false,
  formSettings: {}
};
var _default = exports.default = FlightInput;


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-booking-forms-aps/lib/components/flight-lookup/flight-input.js
// module id = 399
// module chunks = 119